<template>
  <span class="rs-form-check-buttons d-inline-block">
    <RsButton
      :id="id"
      variant="secondary"
      :hollow="!modelValue"
      @click="handleChange(!modelValue)"
    >
      {{ label }}
    </RsButton>
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  model: {
    prop: 'modelValue',
    event: 'change',
  },

  props: {
    id: {
      type: String,
      reduired: true,
    },
    label: {
      type: String,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleChange(value: boolean) {
      this.$emit('change', value);
    },
  },
});
</script>
